export default {
  beforeMount() {
    // init context
    let storeId = 1;
    if (typeof landingStore !== 'undefined') {
      storeId = landingStore;
    }
  }
};
